// extracted by mini-css-extract-plugin
export default {"footer":"ProgressBar_footer__PqStK","progress":"ProgressBar_progress__skXat"};